// extracted by mini-css-extract-plugin
export default {"button":"styles_button__+WpoD","selected":"styles_selected__usw8V"};